<template>
	<div class="landing">
		<span class="landing__logo">
			<svg viewBox="0 0 140 33"><path fill="url(#paint0_linear_301_90)" d="M113.473 27.0913h-7.811c-.021 0-.021-.0212-.021-.0212l7.938-21.39578s0-.02113.021-.02113h1.284c6.148 0 11.075 4.03416 10.654 10.39161-.4 6.083-5.98 11.0465-12.065 11.0465Zm2.211-27.09860133H109.704c-.231 0-.442.14784833-.526.35906133L97.4293 32.0336c-.1263.3591.1264.7604.5264.7604l16.9283-.0422c9.011 0 16.318-8.4063 16.318-17.4462 0-8.78643-6.885-14.95384-15.518-15.31290133Zm-17.8757 0c-.2316 0-.4421.14784833-.5263.35906133L88.4599 24.1554c0 .0211-.021.0211-.0421 0L79.5747.372881c-.0842-.232334-.2948-.359061-.5264-.359061h-5.5795c-.2316 0-.4422.147849-.5264.359061L64.1203 24.1765c0 .0212-.021.0212-.0421 0L55.2562.372881C55.172.140547 54.9614.01382 54.7298.01382h-5.1585c-.4 0-.6737.401304-.5263.760365L60.7936 32.4349c.0843.2324.2948.3591.5264.3591h5.5796c.2316 0 .4422-.1478.5264-.3591l8.822-23.80361c0-.02112.0211-.02112.0421 0l8.8221 23.80361c.0842.2324.2947.3591.5263.3591h5.5796c.2316 0 .4422-.1478.5264-.3591L103.493.774185c.148-.380183-.126-.760365-.526-.760365h-5.1587M37.3384-.00730133c-.2316 0-.4422.14784833-.5264.35906133L27.99 24.1554c0 .0211-.0211.0211-.0422 0L19.1047.330639c-.0842-.211213-.2737-.33794033-.4842-.33794033h-5.6217c-.2106 0-.4211.12672733-.4843.33794033L.765837 32.0125c-.147385.3802.12633.7604.526373.7604h5.15848c.2316 0 .44215-.1479.52637-.3591L15.7991 8.61017c0-.02112.0211-.02112.0421 0l8.8221 23.80363c.0842.2324.2947.3591.5263.3591h5.5796c.2316 0 .4422-.1479.5264-.3591l8.822-23.80363c0-.02112.0211-.02112.0421 0l8.801 23.82473c.0843.2324.2948.3591.5264.3591h5.1585c.4 0 .6737-.4013.5264-.7604L43.4233.372881c-.0842-.232334-.2948-.359061-.5264-.359061h-5.5585M132.086 24.5567c-.442 0-.821.3591-.821.8237v6.5476c0 .4436.358.8238.821.8238h6.527c.442 0 .821-.3591.821-.8238v-6.5476c0-.4435-.358-.8237-.821-.8237h-6.527Z"/><defs><linearGradient
				id="paint0_linear_301_90" x1="-22.3736" x2="210.712" y1="30.2139" y2="-2.43538"
				gradientUnits="userSpaceOnUse"><stop stop-color="#FF4F22"/><stop offset=".4354" stop-color="#FF26AD"/><stop
				offset=".8529" stop-color="#0600EF"/></linearGradient></defs></svg>
	</span>
		<section class="landing__intro landing__block">
			<span class="landing__intro__title">
				Grazie per essere stato con noi a Change Up 2025!
			</span>
			<span class="landing__intro__text">
				MWD Digital è orgogliosa di essere <strong>partner ufficiale</strong> di questo evento che parla di futuro, innovazione e persone.
			</span>
			<span class="landing__intro__subtitle">
				La tech company tailor made
			</span>
			<span class="landing__intro__subtext">
				La passione guida ogni fase del nostro lavoro. Concepiamo, realizziamo e facciamo crescere prodotti digitali che generano valore concreto, ottimizzando ogni dettaglio verso l’eccellenza.
			</span>
			<span class="landing__intro__subtitle">
				La new AI era
			</span>
			<span class="landing__intro__subtext">
				Creiamo soluzioni intelligenti basate sull’intelligenza artificiale, capaci di trasformare le interazioni digitali. Unendo tecnologia avanzata, analisi dati e design centrato sull’uomo, aiutiamo le aziende a innovare il modo di dialogare con il pubblico.
			</span>
			<a href="https://mwd.digital" class="btn filled" target="_blank">
				Conosci MWD digital
			</a>
		</section>
		<section class="landing__intro landing__block">
			<span class="landing__intro__title">
				Digital Business Card
			</span>
			<span class="landing__intro__subtext">
				Hai ricevuto un gadget speciale? Non è un semplice portachiavi, ma un biglietto da visita contactless che rivoluziona il modo di condividere i tuoi contatti. <br />
				<br />
				Basta avvicinare lo smartphone e, in pochi secondi, potrai creare e condividere la tua business card digitale personale. Collegando il gadget a una mail, il tuo "gameboy" porterà direttamente al tuo profilo professionale, sempre aggiornato e a portata di smartphone.<br />
				<br />
				Dimentica la carta: con il nostro sistema hai i tuoi contatti sempre con te, in modo smart, veloce e sostenibile.<br />
				Questo progetto è realizzato con orgoglio "made in MWD", grazie alla nostra passione per la tecnologia e la stampa 3D.<br />
				Clicca il bottone qui sotto per scoprire la realizzazione completa di questo innovativo gadget.
			</span>
			<span class="btn outlinewhite" @click="openVideo">
				Scopri l'ideazione
			</span>
		</section>
		<section class="landing__dyk landing__block">
			<span class="landing__dyk__title">
				Sai cos'è una Digital Business Card?
			</span>
			<span class="landing__dyk__text">
				È l'evoluzione dei tradizionali biglietti da visita. Al suo interno è possibile inserire tutte le proprie informazioni di contatto, facilitando lo scambio rapido e digitale dei recapiti lavorativi.
			</span>
		</section>
		<section class="landing__vcard landing__block">
			<span class="landing__vcard__title">
				Inizia subito a crearla
			</span>
			<figure class="landing__vcard__media">
				<img class="landing__vcard__media__image" src="@/assets/images/vcard.png" alt=""/>
			</figure>
		</section>

		<div class="landing__slideup" :class="{ 'open': slideupOpen }">
			<div class="slideup__panel">
				<span v-if="slideupOpen" class="slideup__close" @click="toggleSlideup">
				<svg viewBox="0 0 24 24"><path fill="#212121"
				                               d="M2.67776 1.82222c.42897-.42882 1.12564-.43043 1.55567-.00098l7.87007 7.87012 7.8702-7.87012.0839-.07617c.4324-.35179 1.0697-.32484 1.4717.07715l.0752.08301c.3287.4032.3286.98552 0 1.38867l-.0752.08301-7.8701 7.87009 8.7266 8.7266.0752.084c.3517.4323.3257 1.0696-.0762 1.4717l-.084.0751c-.4032.3287-.9846.3287-1.3877 0l-.084-.0751-8.7265-8.7266-8.72464 8.7266c-.40266.4021-1.03981.4271-1.47168.0751l-.08398-.0751c-.42881-.4289-.43024-1.1256-.00098-1.5557l8.72558-8.7266-7.86914-7.87009c-.40213-.40268-.42718-1.03885-.07519-1.47071l.07519-.08398Z"/></svg>
			</span>
				<div class="slideup__content" :class="{ 'show': slideupOpen }">
				<span class="slideup__content__title">
					Crea la tua Digital Business Card!
				</span>
					<span class="slideup__content__text">
					Il networking cambia forma. Con il nostro gadget puoi generare un profilo digitale personalizzato.<br/>
					<br/>
					Condividere i tuoi contatti diventa immediato: <strong>basta avvicinare lo smartphone</strong> e in pochi secondi sei già connesso. Il risultato? Un profilo unico, sempre aggiornabile e condivisibile con un semplice gesto.<br/>
					<br/>
					Cosa aspetti? Inserisci i tuoi dati, <strong>personalizza la tua business card</strong> e salva la tua nuova identità digitale.
				</span>
				</div>
				<div class="slideup__ctas">
				<span class="slideup__ctas__trigger btn filled" @click="toggleSlideup"
				      :class="{ 'hidden': slideupOpen }">
					Inizia da qui
				</span>
					<router-link :to="{ name: 'redeem.page', query: { id: code } }"
					             class="btn filled slideup__ctas__btn" :class="{ 'whenactive': slideupOpen }">
						Inizia da qui
					</router-link>
					<a href="https://mwd.digital" class="btn outline slideup__ctas__btn " target="_blank"
					   :class="{ 'whenactive': slideupOpen }">
						Conosci MWD
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {EventBus} from '@/events_bus.js';
export default {
	name: 'Landing',
	props: {
		code: {
			type: String,
			required: true,
		}
	},
	data() {
		return {
			slideupOpen: false,
		}
	},
	methods: {
		openVideo() {
			console.log('open video');
			EventBus.$emit('showvideo');
		},
		toggleSlideup() {
			this.slideupOpen = !this.slideupOpen;
			console.log('####', this.slideupOpen)
		}
	},
	mounted() {
		console.log(this.$route.query.id)
	}
}
</script>

<style lang="scss">
@import '~@/assets/scss/pages/landing';
</style>
